import Vue from 'vue';
import Vuex from 'vuex';
// eslint-disable-next-line no-unused-vars
// import createPersistedState from 'vuex-persistedstate';
import indexPage from './modules/indexPage';
import exam from './modules/exam';

Vue.use(Vuex);


export default new Vuex.Store({
  modules: {
    indexPage,
    exam,
  },
  // plugins: [
  //   createPersistedState(),
  // ],
});
